import { Grid, useMediaQuery } from "@mui/material";
import * as React from "react";
import { makeStyles } from "@mui/styles";
import { RightContainer } from "../components/RightContainer";


const useStyles = makeStyles((theme) => ({
  rootContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    borderRadius: "24px",
    minHeight: "100vh",
  },
  rightContainer: {
    background: "#053742",
    width: "59%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  leftContainer: {
    borderRadius: "24px 0px 0px 24px",
    background: "#ffffff",
    width: "42% !important",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    marginTop: "57px",
  },
}));

const LayoutCompany: React.FC = ({ children }) => {
  const classes = useStyles();
  const matchesIpad = useMediaQuery("(max-width:786px)");
  return (
    <div className={classes.rootContainer} id="top-level-wrapper-left-rigth">
      {matchesIpad ? (
        <Grid container justifyContent={"center"} className={classes.leftContainer} sx={{ width: "100% !important" }}>
          {children}
        </Grid>
      ) : (
        <>
          <Grid container className={classes.leftContainer} id="left-wrapper">
            {children}
          </Grid>

          <Grid className={classes.rightContainer} id="right-wrapper">
            <RightContainer />
          </Grid>
        </>
      )}
    </div>
  );
};

export default LayoutCompany;
